export enum CroStatuses {
  False = 'false',
  TrueByUser = 'true_by_user',
  TrueBySystem = 'true_by_system',
}
